import {
  axiosGetRequest,
  axiosPatchRequest,
  axiosPostRequest,
  getHealthPictureRoute,
} from '../../api';
import { IsabelPregnancy } from './helper';
import {
  IsabelCheckSymptomsRequest,
  IsabelCheckSymptomsResponse,
  IsabelCountries,
  IsabelGeneratePdfRequest,
  IsabelSaveToMyJourneyRequest,
  IsabelSaveToMyJourneyResponse,
} from './models';
import { IsabelKnowledgeUrlsRequest } from './models/IsabelKnowledgeUrlsRequest';
import { IsabelKnowledgeUrlsResponse } from './models/IsabelKnowledgeUrlsResponse';
import { IsabelTriageScoreRequest } from './models/IsabelTriageScoreRequest';
import { IsabelTriageScoreResponse } from './models/IsabelTriageScoreResponse';

export const checkIsabelDiagnosesCall = (
  isabelCheckSymptomsRequest: IsabelCheckSymptomsRequest
) => {
  return axiosGetRequest<IsabelCheckSymptomsResponse>(
    `${getHealthPictureRoute()}/ranked-differential-diagnoses?flag=sortbyRW_advanced&querytext=${
      isabelCheckSymptomsRequest.queryText
    }${
      isabelCheckSymptomsRequest.countryId
        ? `&country_id=${isabelCheckSymptomsRequest.countryId}`
        : ''
    }${
      isabelCheckSymptomsRequest.pregnant &&
      isabelCheckSymptomsRequest.pregnant !== IsabelPregnancy.DONT_KNOW
        ? `&pregnant=${isabelCheckSymptomsRequest.pregnant}`
        : ''
    }${
      isabelCheckSymptomsRequest.sex
        ? `&sex=${isabelCheckSymptomsRequest.sex}`
        : ''
    }${
      isabelCheckSymptomsRequest.birthdate
        ? `&dob=${isabelCheckSymptomsRequest.birthdate}`
        : ''
    }`
  );
};

export const fetchIsabelCountriesCall = () => {
  return axiosGetRequest<IsabelCountries>(
    `${getHealthPictureRoute()}/countries`
  );
};

export const getTriageScoreCall = (
  isabelTriageScoreRequest: IsabelTriageScoreRequest
) => {
  return axiosGetRequest<IsabelTriageScoreResponse>(
    `${getHealthPictureRoute()}/triage-score?querytext=${
      isabelTriageScoreRequest.querytext
    }&pregnancy=${isabelTriageScoreRequest.pregnancy}&age=${
      isabelTriageScoreRequest.age
    }&region=${isabelTriageScoreRequest.region}&sex=${
      isabelTriageScoreRequest.sex
    }&Q1=${isabelTriageScoreRequest.Q1}&Q2=${isabelTriageScoreRequest.Q2}&Q3=${
      isabelTriageScoreRequest.Q3
    }&Q4=${isabelTriageScoreRequest.Q4}&Q5=${isabelTriageScoreRequest.Q5}&Q6=${
      isabelTriageScoreRequest.Q6
    }&Q7=${isabelTriageScoreRequest.Q7}&dx=${isabelTriageScoreRequest.dx}`
  );
};

export const getKnowledgeUrlsCall = (
  isabelKnowledgeUrlsRequest: IsabelKnowledgeUrlsRequest
) => {
  return axiosPostRequest<
    IsabelKnowledgeUrlsRequest,
    IsabelKnowledgeUrlsResponse
  >(`${getHealthPictureRoute()}/knowledge-window`, isabelKnowledgeUrlsRequest);
};

export const saveToMyJourneyCall = (
  journeyId: string,
  isabelSaveToMyJourneyRequest: IsabelSaveToMyJourneyRequest
) => {
  return axiosPatchRequest<
    IsabelSaveToMyJourneyRequest,
    IsabelSaveToMyJourneyResponse
  >(
    `${getHealthPictureRoute()}/isabel/${journeyId}`,
    isabelSaveToMyJourneyRequest
  );
};

export const generatePdfCall = (
  isabelGeneratePdfRequest: IsabelGeneratePdfRequest
) => {
  return axiosPostRequest<IsabelGeneratePdfRequest, any>(
    `${getHealthPictureRoute()}/report`,
    isabelGeneratePdfRequest,
    'arraybuffer'
  );
};
